import { Tooltip } from '@material-ui/core';
import useStyles from './style';
import { IWrapperWithTooltip } from './types';

// TODO: criar testes
const WrapperWithTooltip = ({
  children,
  condition,
  tooltipMessage,
}: IWrapperWithTooltip) => {
  const classes = useStyles();

  if (condition) {
    return (
      <Tooltip
        classes={{ tooltip: classes.tooltipCenterContent }}
        title={<span className={classes.tooltipLabel}>{tooltipMessage}</span>}
        arrow
        interactive
      >
        <span style={{ display: 'flex', justifyContent: 'center' }}>
          {children}
        </span>
      </Tooltip>
    );
  }

  return <>{children}</>;
};

export default WrapperWithTooltip;
